<div class="modal-header" [ngClass]="iconTypeLayoutClass()">
  @if (title) {
    <span class="modal-title">{{ title }}</span>
  }
  <button
    class="close"
    aria-label="Close"
    (click)="closeModal()"
    [ngClass]="iconCustomLayoutClass()"
    >
    <img src="/assets/images/bt-close.svg" width="28px" height="28px" />
  </button>
</div>
<div class="modal-body">
  @if (content) {
    <p>{{ content }}</p>
  }
</div>
<div class="modal-footer">
  <button
    type="button"
    [style.border]="'1px solid transparent'"
    (click)="closeModal()"
    class="btn btn-success small-btn"
    [ngClass]="buttonCustomLayoutCss()"
    >
    {{ confirmButton }}
  </button>
</div>
